export const BUSINESS = {
  name: "The Stone Remedy",
  tagline: "Restoring the integrity and brilliance of fine natural stone.",
  serviceArea: "Servicing Westchester, New York City and Connecticut",
  phone: "914-420-1960",
  phoneHref: "tel:+19144201960",
  email: "thestoneremedy@gmail.com",
  emailHref: "mailto:thestoneremedy@gmail.com?subject=Customer%20Inquiry&body=I%20am%20interested%20in%20a%20free%20estimate...",
  logo: "/tsr-logo.png",
};

export const IMAGES = {
  hero: "/projects/travertine-lobby.jpg",
  residential: "/projects/carrara-kitchen.jpg",
  commercial: "/projects/plaza-lobby.jpg",
  about: "/projects/carrara-island.jpg",
  ba1Before: "/projects/ba1-before.jpg",
  ba1After: "/projects/ba1-after.jpg",
  ba2Before: "/projects/ba2-before.jpg",
  ba2After: "/projects/ba2-after.jpg",
  ba3Before: "/projects/ba3-before.jpg",
  ba3After: "/projects/ba3-after.jpg",
  ba4Before: "/projects/ba4-before.jpg",
  ba4After: "/projects/ba4-after.jpg",
};

export const STONES = [
  { name: "Carrara Marble", note: "Soft veining, timeless." },
  { name: "Calacatta", note: "Bold, dramatic veining." },
  { name: "Granite", note: "Durable & resilient." },
  { name: "Travertine", note: "Warm, earthy, classic." },
  { name: "Limestone", note: "Soft, matte elegance." },
  { name: "Onyx", note: "Translucent & rare." },
  { name: "Quartzite", note: "Hard-wearing luxury." },
  { name: "Slate", note: "Textured, organic." },
  { name: "Terrazzo", note: "Composite artistry." },
  { name: "Soapstone", note: "Quietly distinguished." },
];

export const SERVICES = [
  { title: "Honing", desc: "Removing scratches and etching to a uniform low-sheen finish." },
  { title: "Polishing", desc: "Restoring deep clarity and a true high-gloss shine." },
  { title: "Sealing", desc: "Premium impregnators to protect against staining and moisture." },
  { title: "Crack & Chip Repair", desc: "Color-matched epoxy fills, structural stitching." },
  { title: "Stain & Etch Removal", desc: "Targeted treatment for water rings, oils, and acids." },
  { title: "Grout Cleaning & Color", desc: "Renewing tile lines for a fresh, finished look." },
  { title: "Full Restoration", desc: "Diamond resurfacing for stone returned to factory condition." },
  { title: "Maintenance Programs", desc: "Scheduled care for residences, hotels, and offices." },
];

export const RESIDENTIAL = [
  "Marble & quartzite kitchen countertops",
  "Master bath vanities, tubs and showers",
  "Foyer, gallery and hallway floors",
  "Fireplace surrounds and mantels",
  "Dining and outdoor terrace stone",
];

export const COMMERCIAL = [
  "Hotel and condominium lobbies",
  "Restaurant and retail flooring",
  "Corporate office and elevator banks",
  "High-rise common areas",
  "Houses of worship and historic restoration",
];

export const TESTIMONIALS = [
  {
    quote: "They restored a 1920s Carrara foyer that three other companies told us to replace. It looks original, only better.",
    author: "Eleanor V.",
    role: "Homeowner — Bronxville, NY",
  },
  {
    quote: "Our hotel lobby is the first impression for thousands of guests a week. The Stone Remedy keeps it immaculate without ever disrupting operations.",
    author: "Marcus B.",
    role: "GM — Manhattan Boutique Hotel",
  },
  {
    quote: "Calacatta island, a deep wine stain, two days before a dinner party. They saved us — and the stone — overnight.",
    author: "Priya R.",
    role: "Homeowner — Greenwich, CT",
  },
  {
    quote: "Professional, quiet, and meticulous. Our partners noticed the marble before they noticed our renovation.",
    author: "David L.",
    role: "Managing Partner — Midtown Law Firm",
  },
];
